import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import {MatExpansionModule} from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { NavbarComponent } from './navbar/navbar.component';
import { HttpClientModule } from '@angular/common/http';
import { FooterComponent } from './footer/footer.component';
import {MatBadgeModule} from '@angular/material/badge';
import { WelcomeComponent } from './welcome/welcome.component';

@NgModule({
  declarations: [
    NavbarComponent,
    FooterComponent,
    WelcomeComponent
  ],
  exports: [
    NavbarComponent,
    FooterComponent,
    WelcomeComponent
  ],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatExpansionModule,
    RouterModule,
    FlexLayoutModule,
    HttpClientModule,
    MatBadgeModule
  ]
})
export class NavbarModule { }
